(function () {
  const deselectedUpsells = new Set();
  let isRemovingUpsell = false;
  let isCheckingCart = false;
  let isAddingShipping = false;

  // ─── SessionStorage helpers ───────────────────────────────────────────────────
  const SESSION_KEY = 'cs_shipping_added';

  function markShippingAdded(handle) {
    try {
      const data = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
      data[handle] = true;
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch(e) {}
  }

  function clearShippingMark(handle) {
    try {
      const data = JSON.parse(sessionStorage.getItem(SESSION_KEY) || '{}');
      delete data[handle];
      sessionStorage.setItem(SESSION_KEY, JSON.stringify(data));
    } catch(e) {}
  }

  function clearAllShippingMarks() {
    try { sessionStorage.removeItem(SESSION_KEY); } catch(e) {}
  }

  // ─── Cart drawer re-render ────────────────────────────────────────────────────
  function renderAndRefreshCart(sectionsData) {
    if (!sectionsData) return;
    if (sectionsData['cart-drawer']) {
      var parser = new DOMParser();
      var doc = parser.parseFromString(sectionsData['cart-drawer'], 'text/html');
      var newDrawer = doc.querySelector('#CartDrawer');
      var curDrawer = document.querySelector('#CartDrawer');
      if (newDrawer && curDrawer) {
        curDrawer.innerHTML = newDrawer.innerHTML;

        // Empty cart fix: cart items nahi hain to is-empty class add karo
        var cartDrawerEl = document.querySelector('cart-drawer');
        if (cartDrawerEl) {
          var hasItems = curDrawer.querySelector('.cart-item');
          if (!hasItems) {
            cartDrawerEl.classList.add('is-empty');
          } else {
            cartDrawerEl.classList.remove('is-empty');
          }
        }
      }
    }
    if (sectionsData['cart-icon-bubble']) {
      var parser2 = new DOMParser();
      var doc2 = parser2.parseFromString(sectionsData['cart-icon-bubble'], 'text/html');
      var newBubble = doc2.querySelector('.shopify-section') || doc2.body;
      var curBubble = document.getElementById('cart-icon-bubble');
      if (curBubble && newBubble) curBubble.innerHTML = newBubble.innerHTML;
    }
  }

  // ─── Sirf drawer HTML refresh ─────────────────────────────────────────────────
  function refreshDrawerSections() {
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        updates: {},
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((data) => { if (data.sections) renderAndRefreshCart(data.sections); })
      .catch(() => {});
  }

  // ─── Item key se remove + sections refresh ────────────────────────────────────
  function removeItemAndRefresh(itemKey, fallbackEl) {
    if (isRemovingUpsell) return;
    isRemovingUpsell = true;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: itemKey,
        quantity: 0,
        sections: 'cart-drawer,cart-icon-bubble',
        sections_url: window.location.pathname,
      }),
    })
      .then((r) => r.json())
      .then((data) => {
        isRemovingUpsell = false;
        if (data.sections) renderAndRefreshCart(data.sections);
      })
      .catch(() => {
        isRemovingUpsell = false;
        if (fallbackEl && fallbackEl.removeFromCart) fallbackEl.removeFromCart();
      });
  }

  // ─── Handle se find karke remove karo ────────────────────────────────────────
  function removeHandleFromCart(handle, fallbackEl) {
    if (isRemovingUpsell) return;
    isRemovingUpsell = true;
    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        const item = cart.items.find(
          (i) => i.handle === handle || i.product_handle === handle
        );
        if (!item) { isRemovingUpsell = false; return; }
        isRemovingUpsell = false;
        removeItemAndRefresh(item.key, fallbackEl);
      })
      .catch(() => {
        isRemovingUpsell = false;
        if (fallbackEl && fallbackEl.removeFromCart) fallbackEl.removeFromCart();
      });
  }

  // ─── Shipping add karo ────────────────────────────────────────────────────────
  function addShippingToCart(offerEl) {
    if (isAddingShipping) return;
    const handle = offerEl.dataset.handle;
    if (!handle) return;
    if (deselectedUpsells.has(handle)) return;
    isAddingShipping = true;
    markShippingAdded(handle);
    if (typeof offerEl.addToCart === 'function') {
      offerEl.addToCart();
    }
    setTimeout(() => { isAddingShipping = false; }, 100);
  }

  // ─── CORE FIX: Real cart check — shipping quantity check ─────────────────────
  function checkCartAndHandleShipping() {
    if (isCheckingCart || isRemovingUpsell) return;
    isCheckingCart = true;

    const offerEls = Array.from(
      document.querySelectorAll('cart-drawer-upsell[data-toggle="true"], cart-drawer-gift')
    );
    if (!offerEls.length) { isCheckingCart = false; return; }

    const offerHandles = offerEls.map((el) => el.dataset.handle).filter(Boolean);

    fetch('/cart.js')
      .then((r) => r.json())
      .then((cart) => {
        isCheckingCart = false;

        const mainItems = cart.items.filter(
          (i) => !offerHandles.includes(i.handle) && !offerHandles.includes(i.product_handle)
        );
        const hasMain = mainItems.length > 0;

        if (hasMain) {
          offerEls.forEach((el) => {
            const handle = el.dataset.handle;
            if (!handle) return;

            // ─── ASLI FIX ────────────────────────────────────────────────────
            // Real cart se check karo — shipping item hai aur quantity kitni hai
            const shippingItem = cart.items.find(
              (i) => i.handle === handle || i.product_handle === handle
            );

            if (shippingItem) {
              // Shipping cart mein hai
              markShippingAdded(handle);

              if (shippingItem.quantity > 1) {
                // Quantity 2 ya zyada ho gayi — 1 pe wapas lao
                fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify({
                    id: shippingItem.key,
                    quantity: 1,
                    sections: 'cart-drawer,cart-icon-bubble',
                    sections_url: window.location.pathname,
                  }),
                })
                  .then((r) => r.json())
                  .then((data) => { if (data.sections) renderAndRefreshCart(data.sections); })
                  .catch(() => {});
              }

              if (!deselectedUpsells.has(handle)) {
                el.dataset.selected = 'true';
                const cb = el.querySelector('input[type="checkbox"]');
                if (cb) cb.checked = true;
              }
              return; // Shipping cart mein hai — BILKUL ADD MAT KARO
            }

            // Shipping cart mein nahi hai
            if (deselectedUpsells.has(handle)) return;

            // Ab add karo
            el.dataset.selected = 'true';
            const cb = el.querySelector('input[type="checkbox"]');
            if (cb) cb.checked = true;

            addShippingToCart(el);
          });

        } else {
          // Main product nahi — sab clear karo
          clearAllShippingMarks();

          offerEls.forEach((el) => {
            el.dataset.selected = 'false';
            const cb = el.querySelector('input[type="checkbox"]');
            if (cb) cb.checked = false;
          });

          const shippingItem = cart.items.find(
            (i) => offerHandles.includes(i.handle) || offerHandles.includes(i.product_handle)
          );

          if (shippingItem) {
            removeItemAndRefresh(shippingItem.key, null);
          } else {
            refreshDrawerSections();
          }
        }
      })
      .catch(() => { isCheckingCart = false; });
  }

  // ─── reconcileDrawerOffers override ──────────────────────────────────────────
  window.reconcileDrawerOffers = function (container) {
    if (!container) return false;

    const offers = container.querySelectorAll(
      'cart-drawer-gift, cart-drawer-upsell[data-toggle="true"]'
    );
    if (!offers.length) return false;

    const offerHandles = Array.from(offers)
      .map((el) => el.dataset.handle)
      .filter(Boolean);

    let mainCount = 0;
    container.querySelectorAll('.cart-item').forEach((item) => {
      const isOffer = offerHandles.some((h) =>
        item.classList.contains('cart-item--product-' + h)
      );
      if (!isOffer) mainCount++;
    });
    const hasMain = mainCount > 0;

    const addList = [];
    const removeList = [];

    offers.forEach((el) => {
      const handle = el.dataset.handle;
      const inCart = !!container.querySelector('.cart-item--product-' + handle);

      if (!hasMain) {
        el.dataset.selected = 'false';
        const cb = el.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = false;
        if (inCart) removeList.push(el);
        return;
      }

      if (!deselectedUpsells.has(handle) && el.dataset.selected !== 'true') {
        el.dataset.selected = 'true';
        const cb = el.querySelector('input[type="checkbox"]');
        if (cb) cb.checked = true;
      }

      if (deselectedUpsells.has(handle)) {
        el.dataset.selected = 'false';
        if (inCart) removeList.push(el);
        return;
      }

      if (typeof el.getUpdateRequired !== 'function') return;
      if (!el.getUpdateRequired()) return;

      if (inCart) {
        if (el.dataset.selected === 'false') removeList.push(el);
      } else {
        if (el.dataset.selected === 'true') addList.push(el);
      }
    });

    // Remove
    if (removeList.length && !isRemovingUpsell) {
      const el = removeList[0];
      const handle = el.dataset.handle;
      clearShippingMark(handle);
      const cartItemEl = container.querySelector('.cart-item--product-' + handle);
      if (cartItemEl) {
        const key = cartItemEl.dataset.key;
        if (key) {
          removeItemAndRefresh(key, el);
        } else {
          el.removeFromCart && el.removeFromCart();
          setTimeout(() => { isRemovingUpsell = false; }, 100);
        }
      } else {
        removeHandleFromCart(handle, el);
      }
      return true;
    }

    
    if (addList.length && !isAddingShipping) {
      checkCartAndHandleShipping();
      return true;
    }

    if (!hasMain) {
      checkCartAndHandleShipping();
    }

    return false;
  };

  // ─── Toggle click handler ─────────────────────────────────────────────────────
  function patchCartDrawerUpsell() {
    const OrigClass = customElements.get('cart-drawer-upsell');
    if (!OrigClass) { setTimeout(patchCartDrawerUpsell, 300); return; }

    document.addEventListener('click', function (e) {
      const upsellEl = e.target.closest('cart-drawer-upsell[data-toggle="true"]');
      if (!upsellEl) return;
      const handle = upsellEl.dataset.handle;
      if (!handle) return;
      setTimeout(() => {
        const isSelected = upsellEl.dataset.selected === 'true';
        if (!isSelected) {
          deselectedUpsells.add(handle);
          clearShippingMark(handle);
        } else {
          deselectedUpsells.delete(handle);
          clearShippingMark(handle); // Allow re-add
        }
      }, 50);
    }, true);
  }

  patchCartDrawerUpsell();

  // ─── Remove button hook ───────────────────────────────────────────────────────
  document.addEventListener('click', function (e) {
    const removeBtn = e.target.closest(
      'cart-remove-button, .cart-item__remove, [data-action="remove-item"], .item__remove'
    );
    if (!removeBtn) return;
    setTimeout(() => checkCartAndHandleShipping(), 100);
  });

  // ─── MutationObserver ─────────────────────────────────────────────────────────
  const observer = new MutationObserver(() => {
    document.querySelectorAll('cart-drawer-upsell[data-toggle="true"]').forEach((el) => {
      const handle = el.dataset.handle;
      if (!handle) return;
      if (deselectedUpsells.has(handle) && el.dataset.selected !== 'false') {
        el.dataset.selected = 'false';
      }
    });
  });

  function startObserver() {
    const drawer = document.querySelector('cart-drawer, #CartDrawer');
    if (drawer) {
      observer.observe(drawer, { childList: true, subtree: true, attributes: false });
    } else {
      setTimeout(startObserver, 100);
    }
  }
  startObserver();

  // ─── cartQuantityUpdated ──────────────────────────────────────────────────────
  document.addEventListener('cartQuantityUpdated', function () {
    checkCartAndHandleShipping();
  });

  // ─── DOMContentLoaded ────────────────────────────────────────────────────────

  document.addEventListener('DOMContentLoaded', function () {
    checkCartAndHandleShipping();
  });

})();